import { render } from "./userinfo.vue?vue&type=template&id=3b459ef0&scoped=true"
import script from "./userinfo.vue?vue&type=script&lang=js"
export * from "./userinfo.vue?vue&type=script&lang=js"

import "./userinfo.vue?vue&type=style&index=0&id=3b459ef0&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\padma_erp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b459ef0"]])

export default __exports__